import { render, staticRenderFns } from "./ScrollingSiteMessenger.vue?vue&type=template&id=48682d00"
import script from "./ScrollingSiteMessenger.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollingSiteMessenger.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScrollingSiteMessenger.vue?vue&type=style&index=0&id=48682d00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports